import React from "react";
import View from '../../pages/registration';

class Registration extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            redirect: false,
        };
    }

    registration = (email, password, source, receive_newsletter, receive_updates) => {
        let isNewsLetter = false;
        let isUpdates = false;
        if (receive_newsletter && receive_newsletter[0] === 'on') { 
            isNewsLetter = true;
        }
        if (receive_updates && receive_updates[0] === 'on') { 
            isUpdates = true;
        }
            this.props.registerUser(email, password, source, isNewsLetter, isUpdates)
            .then((res) => {
                if(res) {
                    this.props.history.push("/login");
                }
            })
        
    };
    setRedirect = () => {
        this.setState({
            redirect: true
        })
    };

    componentDidMount() {
        this.props.registerSource();
    }

    render() {
        const {redirect} = this.state;
        const {source} = this.props;
        return (
            <View
                registrationUser={this.registration}
                redirect={redirect}
                source={source}
                setRedirect={this.setRedirect}

            />
        );
    }
}
export default Registration;
